var map = {
	"./3star.webp": 8676,
	"./4star.webp": 3946,
	"./5star.webp": 7274,
	"./bg-bow.webp": 1105,
	"./bg-catalyst.webp": 2852,
	"./bg-claymore.webp": 2281,
	"./bg-polearm.webp": 2612,
	"./bg-sword.webp": 2727,
	"./history-select.webp": 4216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9552;